export default '/build/54c5283b.svg'